import { useEffect, useState } from "react";
import { DateTime } from "luxon";
import toast from "react-hot-toast";
import { ApiGetSimpleReport } from "@/legacy/ApiCallerOld";
import { useCache } from "@/Hooks/useCache";
import { SimpleReport } from "./SimpleReport";

interface TicketsByPriorityProps {
	dateRange: [DateTime, DateTime];
}

export function TicketsByPriority(props: TicketsByPriorityProps) {
	const cache = useCache();
	const [data, setData] = useState<number[][]>([]);

	useEffect(() => {
		doFetch();

		async function doFetch() {
			const response = await ApiGetSimpleReport("reports/tickets-by-priority", props.dateRange[0], props.dateRange[1]);

			if (response != null && response.data != null && response.data.data != null) {
				setData(response.data.data);
			} else {
				toast.error("Could not fetch report data.");
			}
		}
	}, [props.dateRange]);

	function dataXTransformer(data: number): string {
		return cache.getPriority(data)?.name ?? "Unknown";
	}

	return (
		<SimpleReport
			title="Tickets by Priority"
			subtitle="Shows tickets in the reporting period split by priority."
			axisTitles={{ xLabel: "Priority", yLabel: "Tickets" }}
			data={data}
			dataXTransformer={dataXTransformer}
			dateRange={props.dateRange}
		/>
	);
}
